import type { ApprovalStatus, ApprovalStepStatus, UserRole } from '../../types/domain';

export const roleLabels: Record<UserRole, string> = {
  superadmin: 'Суперадминистратор',
  admin: 'Администратор',
  manager: 'Менеджер по продажам',
  head: 'Руководитель',
  approver: 'Согласующий',
};

export function normalizeUserRole(role: string | null | undefined): UserRole {
  if ((role === 'admin' || role === 'superadmin') || role === 'head' || role === 'approver') return role;
  return 'manager';
}

export function canManagePricing(role: UserRole | null): boolean {
  return role === 'admin' || role === 'superadmin' || role === 'head';
}

export function canDecideAnyApprovalStep(role: UserRole | null): boolean {
  return role === 'admin' || role === 'superadmin' || role === 'head';
}

export function canCommentOnQuote(role: UserRole | null): boolean {
  return role === 'approver' || role === 'admin' || role === 'superadmin' || role === 'head';
}

export function canViewQuoteComments(role: UserRole | null): boolean {
  return role === 'manager' || canCommentOnQuote(role);
}

export function canEditOwnQuoteComment(role: UserRole | null, userId: string | undefined, authorId: string | null): boolean {
  return role === 'approver' && Boolean(userId) && userId === authorId;
}

export function canCompleteQuoteComment(role: UserRole | null): boolean {
  return role === 'manager';
}

export function canWithdrawOwnApproval(
  role: UserRole | null,
  userId: string | undefined,
  approverId: string,
  stepStatus: ApprovalStepStatus,
  requestStatus: ApprovalStatus,
  isCurrentVersion: boolean,
): boolean {
  return role === 'approver'
    && userId === approverId
    && stepStatus === 'approved'
    && (requestStatus === 'pending' || requestStatus === 'approved')
    && isCurrentVersion;
}

export function canEditQuote(
  role: UserRole | null,
  userId: string | undefined,
  ownerId: string,
  approvalStatus: ApprovalStatus,
  hasApprovedStep = false,
): boolean {
  if ((role === 'admin' || role === 'superadmin') || role === 'head') return true;
  return role === 'manager'
    && userId === ownerId
    && !hasApprovedStep
    && (approvalStatus === 'draft' || approvalStatus === 'needs_revision' || approvalStatus === 'pending');
}

export function canSubmitQuote(role: UserRole | null, userId: string | undefined, ownerId: string): boolean {
  return role === 'admin' || role === 'superadmin' || role === 'head' || (role === 'manager' && userId === ownerId);
}
